import { render, staticRenderFns } from "./RouteAssessmentMetricsReportCard.vue?vue&type=template&id=554cbbd6&scoped=true&"
import script from "./RouteAssessmentMetricsReportCard.vue?vue&type=script&lang=js&"
export * from "./RouteAssessmentMetricsReportCard.vue?vue&type=script&lang=js&"
import style0 from "./RouteAssessmentMetricsReportCard.vue?vue&type=style&index=0&id=554cbbd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554cbbd6",
  null
  
)

export default component.exports